<template>
<div class="chapter">
<div class="inner_page">
<div class="contents">
<a id="TOC1"><p class="contentsHead">Contents</p>
</a><p class="contentsEntry"><a id="TOC1"></a><span href="#/e9781338162905_title001#tp01" title="Link target outside of Sample">Title Page</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ded001#ded01" title="Link target outside of Sample">Dedication</span></p>
<p class="contentsEntry"><a href="#/e9781338162905_ch001#ch1">Chapter One: Too Bad, So Sad</a></p>
<p class="contentsEntry"><a href="#/e9781338162905_ch002#ch2">Chapter Two: Rain, Rain, Go Away</a></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch003#ch3" title="Link target outside of Sample">Chapter Three: Milk and Cookies</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch004#ch4" title="Link target outside of Sample">Chapter Four: Ninety-Nine, One Hundred</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch005#ch5" title="Link target outside of Sample">Chapter Five: Up All Night</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch006#ch6" title="Link target outside of Sample">Chapter Six: Fit for a Princess</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch007#ch7" title="Link target outside of Sample">Chapter Seven: Having a Ball</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch008#ch8" title="Link target outside of Sample">Chapter Eight: Brainstorm</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch009#ch9" title="Link target outside of Sample">Chapter Nine: Dial P for Princess</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch010#ch10" title="Link target outside of Sample">Chapter Ten: Poster the Town</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch011#ch11" title="Link target outside of Sample">Chapter Eleven: Another Knock at the Door</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch012#ch12" title="Link target outside of Sample">Chapter Twelve: Are You Smarter than a Fifth Grader?</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch013#ch13" title="Link target outside of Sample">Chapter Thirteen: Alligator Snack</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch014#ch14" title="Link target outside of Sample">Chapter Fourteen: Tricks &amp; Treats</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch015#ch15" title="Link target outside of Sample">Chapter Fifteen: And the Answer Is …</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch016#ch16" title="Link target outside of Sample">Chapter Sixteen: Overboard</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ch017#ch17" title="Link target outside of Sample">Chapter Seventeen: Human Ladder</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_bm001#bm1" title="Link target outside of Sample">Teaser</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ack001#ack01" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_ata001#ata01" title="Link target outside of Sample">About the Author</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_bm002#bm2" title="Link target outside of Sample">Read all the Whatever After books!</span></p>
<p class="contentsEntry"><span href="#/e9781338162905_copy001#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781338162905_toc001.vue?77c4359f